import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { IconsService } from 'app/core/icons/icons.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export const provideIcons = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        provideEnvironmentInitializer(() => inject(IconsService)),
        {
            provide: 'ICON_REGISTRATION',
            useFactory: (
                matIconRegistry: MatIconRegistry, 
                domSanitizer: DomSanitizer
            ) => {
                // Registra iconos de banderas
                matIconRegistry.addSvgIconSet(
                    domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/flags.svg')
                );
            },
            deps: [MatIconRegistry, DomSanitizer],
            multi: true
        }
    ];
};
